import { useTenantMemberships } from "@/contexts/TenantContext";
import { resolveTenantToSelect } from "@/hooks/resolveTenantToSelect";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export function useChangeTenantIfNeeded() {
  const [searchParams] = useSearchParams();
  const { currentTenantMembership, workspaceState, setSelectedTenantMembership } = useTenantMemberships();

  const tenantExternalId = searchParams.get("tenantExternalId");

  useEffect(() => {
    const targetMembership = resolveTenantToSelect(
      tenantExternalId,
      currentTenantMembership?.tenant?.externalId,
      workspaceState?.selectedWorkspace?.memberships ?? []
    );
    if (targetMembership) {
      setSelectedTenantMembership(targetMembership);
    }
  }, [tenantExternalId, currentTenantMembership, workspaceState]);
}
